export interface CheckoutIntent {
  course_id: string;
  course_title: string;
  price: number;
  currency: 'USD';
  created_at: string;
}

const INTENT_KEY = 'wa_checkout_intent';
const PURCHASE_TRACKED_PREFIX = 'wa_meta_purchase_tracked:';
const INTENT_MAX_AGE_MS = 24 * 60 * 60 * 1000;

export const saveCheckoutIntent = (intent: CheckoutIntent) => {
  try {
    sessionStorage.setItem(INTENT_KEY, JSON.stringify(intent));
  } catch {
    // storage unavailable — tracking degrades gracefully
  }
};

export const readCheckoutIntent = (): CheckoutIntent | null => {
  try {
    const raw = sessionStorage.getItem(INTENT_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw) as Partial<CheckoutIntent>;
    if (
      typeof parsed.course_id !== 'string' ||
      typeof parsed.course_title !== 'string' ||
      typeof parsed.price !== 'number' ||
      typeof parsed.created_at !== 'string'
    ) {
      return null;
    }

    const createdAt = Date.parse(parsed.created_at);
    if (Number.isNaN(createdAt) || Date.now() - createdAt > INTENT_MAX_AGE_MS) {
      return null;
    }

    return parsed as CheckoutIntent;
  } catch {
    return null;
  }
};

export const clearCheckoutIntent = () => {
  try {
    sessionStorage.removeItem(INTENT_KEY);
  } catch {
    // noop
  }
};

export const isPurchaseTracked = (sessionId: string) => {
  try {
    return localStorage.getItem(PURCHASE_TRACKED_PREFIX + sessionId) === '1';
  } catch {
    return false;
  }
};

export const markPurchaseTracked = (sessionId: string) => {
  try {
    localStorage.setItem(PURCHASE_TRACKED_PREFIX + sessionId, '1');
  } catch {
    // noop
  }
};
